import TripHistoryComponent from "../../components/TripHistory/TripHistoryComponent";

const TripHistory = () => {
  return <TripHistoryComponent />;
};

export default TripHistory;
